import { gql } from '@apollo/client/core'

export const GET_USER_SETTINGS = gql`
  query GetUserSettings {
    getUserSettings {
      id
      calendar_id
      timezone
      default_calendar_view
      working_hours_display
      email_notifications
      min_notice_minutes
      max_advance_days
      default_appointment_duration
      created_at
      updated_at
    }
  }
`

export const GET_USER_TIMEZONE = gql`
  query GetUserTimezone {
    getUserTimezone {
      calendar_id
      timezone
    }
  }
`
export const GET_CUSTOMER_SCHEDULE = gql`
  query GetCustomerSchedule($customerId: Int!, $clinicId: Int!) {
    getCustomerSchedule(customerId: $customerId, clinicId: $clinicId) {
      calendar_id
      customer_id
      clinic_id
      weekly_schedule {
        weekday
        start_time
        end_time
      }
      exceptions {
        exception_id
        date
        is_available
        start_time
        end_time
      }
      timezone
    }
}
`

export const GET_PRACTICE_EVENT_TYPES = gql`
  query GetPracticeEventTypes {
    getPracticeEventTypes{
      id
      practice_id
      name
      color_hex
      created_by
      updated_by
      created_at
      updated_at
    }
  }
`

export const GET_OAUTH_CONNECTION_STATUS = gql`
  query {
    get_oauth_connection_status {
      provider
      isConnected
      lastSync
      calendarId
    }
  }
`

export const GET_PRACTICE_INFO_SETTINGS = gql`
  query GetPracticeInfoSettings($customer_id: String!, $clinic_id: String!) {
    customerSettings(CustomerSettingsInput: { customer_id: $customer_id, clinic_id: $clinic_id }) {
      practiceInfoPersonal {
        practice_name
        contact_info {
          primary_phone
        }
        office_address {
          address_line_1
          address_line_2
          city
          state
          zip
          country
        }
      }
      practiceInfoPractice {
        practice_name
        contact_info {
          primary_phone
        }
        office_address {
          address_line_1
          address_line_2
          city
          state
          zip
          country
        }
      }
    }
  }
`